import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Add } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { Helmet } from 'react-helmet-async';
import { PageHeader } from 'components/page-header';
import { pageTitle } from 'utils/page-title';
import routes from '~/routes';
import DiscountRateScenariosContent from './discount-rate-scenarios-content';

/**
 * Entry page for the Discount Rate / Risking Configuration list.
 * @return {JSX.Element} The list page
 */
const DiscountRateScenariosPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <Helmet>
        <title>{pageTitle('Discount Rate / Risking Configuration')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[]}
        title="Discount Rate / Risking Configuration"
        actions={
          <Button
            renderIcon={Add}
            kind="primary"
            onClick={() => history.push(routes.newDiscountRateScenarioPath)}
          >
            Create Discount Rate Scenario
          </Button>
        }
      />
      <DiscountRateScenariosContent />
    </>
  );
};

export { DiscountRateScenariosPage };
